import { z } from "zod";

import { DirectLink } from "../../components/ui/Link";
import { Product } from "../models/partials/Product";
import { ErrorResponse, SuccessResponse } from "./standard-responses";

export const authEndpoints = {
  "auth.token.confirm": (p: { token: string }) => ["*", "post", `/t/${p.token}`],
  "auth.token.delete": (p: { token: string }) => ["*", "delete", `/t/${p.token}`],
} as const satisfies Record<string, (p: any) => ["up" | "*", "get" | "delete" | "post" | "put", `/${string}`]>;

export const authRequests = {
  "auth.token.confirm": z.object({
    token: z.string(),
  }),
  "auth.token.delete": z.object({
    token: z.string(),
  }),
} as const;

export const authResponses = {
  "auth.token.confirm": SuccessResponse.extend({
    redirect: z.boolean(),
    redirectTo: z.custom<DirectLink>().optional(),
  }).or(
    ErrorResponse.extend({
      error: z.enum(["wrong_link", "already_logged_in", "not_found"]).nullable(),
    }),
  ),
  "auth.token.delete": SuccessResponse,
} as const;
